import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { NetworkSelectData } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network-select-data";
import { SendTrackingFacade } from "@modules/main/components/step-summary/sending-modal/services/send-tracking.facade";
import { SendWarningComponent } from "@modules/main/components/step-summary/sending-modal/send-warning/send-warning.component";

@Component({
	selector: "send-select-network",
	templateUrl: "./send-select-network.component.html",
	styleUrls: ["./send-select-network.component.scss"],
	providers: [SendTrackingFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SendSelectNetworkComponent implements OnInit {
	@Input() availableNetworks: Network[] = [];
	@Input() unavailableNetworks: Network[] = [];
	@Input() selectedCryptocoin: PaymentsCryptocoin = null;
	@Input() walletId = "";

	constructor(
		private readonly modalService: ModalService,
		private readonly trackinService: SendTrackingFacade
	) {}

	ngOnInit(): void {
		this.trackinService.trackSendNetworkListViewed();
	}

	public onBackButtonClick(): void {
		this.modalService.pop();
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public selectNetwork(network: NetworkSelectData): void {
		this.trackinService.trackSendNetworkListClicked(network.selectedNetworkName);
		this.modalService
			.create(SendWarningComponent, {
				selectedCryptocoin: this.selectedCryptocoin,
				walletId: this.walletId,
				selectedNetwork: this.selectedCryptocoin.networks.find((item) => item.id === network.selectedNetworkId)
			})
			.present();
	}
}
